export interface MasterProfilePathEntry {
  date: string;
  text: string;
}

const MASTER_PROFILE_PATH_DATE = /^(19\d{2}|20\d{2}|2100)-(0[1-9]|1[0-2])$/;

export function isMasterProfilePathDate(value: string): boolean {
  return MASTER_PROFILE_PATH_DATE.test(value);
}

export function parseMasterProfilePath(data: unknown): MasterProfilePathEntry[] {
  const source = Array.isArray(data)
    ? data
    : typeof data === 'object' && data !== null && 'path' in data
      ? (data as { path?: unknown }).path
      : [];
  if (!Array.isArray(source)) return [];

  const byDate = new Map<string, MasterProfilePathEntry>();
  source.forEach((entry) => {
    if (typeof entry !== 'object' || entry === null) return;
    const { date, text } = entry as { date?: unknown; text?: unknown };
    if (typeof date !== 'string' || typeof text !== 'string') return;
    const normalizedDate = date.trim();
    if (!isMasterProfilePathDate(normalizedDate) || byDate.has(normalizedDate)) return;
    byDate.set(normalizedDate, { date: normalizedDate, text: text.trim() });
  });

  return [...byDate.values()].sort((left, right) => left.date.localeCompare(right.date));
}

export function normalizeMasterProfilePath(
  path: readonly MasterProfilePathEntry[],
): MasterProfilePathEntry[] {
  const byDate = new Map<string, MasterProfilePathEntry>();

  path.forEach((entry) => {
    const date = entry.date.trim();
    const text = entry.text.trim();
    if (!isMasterProfilePathDate(date)) {
      throw new Error(`Некорректная дата пути мастера: ${entry.date}`);
    }
    if (!text) {
      throw new Error(`Укажите, что произошло в ${date}.`);
    }
    if (!byDate.has(date)) {
      byDate.set(date, { date, text });
    }
  });

  return [...byDate.values()].sort((left, right) => left.date.localeCompare(right.date));
}
